import { ReactNode } from 'react';
import styles from './List.module.css';

type ListProps = {
  className?: string;
  items: ReactNode[];
};

const List = ({ items, className }: ListProps) => (
  <ul className={[styles.list, className].filter(Boolean).join(" ")}>
    {items.map((item, idx) => (
      <li className={styles.item} key={idx}>
        {item}
      </li>
    ))}
  </ul>
);

export default List;
